import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import RcSlider from 'rc-slider';

var defaultTipFormatter = function defaultTipFormatter(x) {
  return "" + x;
};
/**
 * A Component to allow make selections from a range of values.
 */
var Slider = function Slider(_a) {
  var className = _a.className,
    includeMarks = _a.includeMarks,
    _a$step = _a.step,
    step = _a$step === undefined ? undefined : _a$step,
    min = _a.min,
    max = _a.max,
    propMarks = _a.marks,
    _a$tipFormatter = _a.tipFormatter,
    tipFormatter = _a$tipFormatter === undefined ? defaultTipFormatter : _a$tipFormatter,
    rest = __rest(_a, ["className", "includeMarks", "step", "min", "max", "marks", "tipFormatter"]);
  var marks = propMarks || {};
  if (includeMarks && step !== undefined && min !== undefined && max !== undefined) {
    for (var markIndicator = min; markIndicator <= max; markIndicator += step || 1) {
      marks[markIndicator] = {
        label: tipFormatter(markIndicator)
      };
    }
  }
  return jsx(RcSlider, Object.assign({
    className: classNames('cogs-v10', 'cogs-slider', className),
    step: step,
    marks: marks,
    min: min,
    max: max
  }, rest));
};

export { Slider };
